import {  ChangeDetectorRef, Component, EventEmitter,  Input, OnDestroy, OnInit, Output } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import moment from 'moment';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

interface Jahresbelegung {
    jahr: string;
    start: string;
    availability: string;
}

interface Month {
    id: string; // 2021-09-28
    value: string;
    class: string;
    tooltip: string;
}

interface Calendar {
    w_0: Month[],
    w_1: Month[],
    w_2: Month[],
    w_3: Month[],
    w_4: Month[],
    w_5: Month[],
    header?: string;
    class?: string;
}

@Component({
    selector: 'clever-ferienhauserofferzeit',
    templateUrl: './ferienhauserofferzeit.component.html',
    styleUrls: ['./ferienhauserofferzeit.component.scss'],
    standalone: false
})
export class FerienhauserofferzeitComponent implements OnInit, OnDestroy {
    @Input() jahresbelegung: Jahresbelegung[];
    @Input() start: string;
    @Input() end: string;

    @Output() sendStart: EventEmitter<string> = new EventEmitter<string>();
    @Output() sendEnd: EventEmitter<string> = new EventEmitter<string>();

    header_week: string[] = ['MO', 'DI', 'MI', 'DO', 'FR', 'SA', 'SO'];
    currentFisrtDate: string = moment().startOf('month').format('YYYY-MM-DD');
    currentSecondDate: string = moment().startOf('month').format('YYYY-MM-DD');

    first_month: Calendar;
    second_month: Calendar;

    alredyCut: boolean = false;
    tmp_start_date: string;

    protected categorys = {
        A: 'Nicht belegt',
        B: 'Nicht belegt, Anreisetag',
        C: 'Nicht belegt, ungeteilt (z.B. Weihnachts-Zeitraum)',
        F: 'Reserviert vom Besitzer (nach Anfrage) Anreisetag',
        H: 'Reserviert vom Besitzer (nach Anfrage)',
        N: 'Gebucht, Anreisetag',
        O: 'Gebucht',
        T: 'Belegt vom Besitzer, Anreisetag',
        V: 'Belegt vom Besitzer, Beispiel - und Referenzdateien',
    };

    calendars: Observable<Calendar[]>;

    today: string = moment().format('YYYY-MM-DD');
    tmp_end: Month;
    first_header: string = '';
    second_header: string = '';
    media: string = '';

    currentYearFirst: string;
    currentYearSecond: string;

    protected unsubscribe$ = new Subject();
    initDate: BehaviorSubject<{ first: string, second: string }>;
    temInit: BehaviorSubject<Month>;
    constructor(
        protected cdr: ChangeDetectorRef,
        protected mediaObserver: BreakpointObserver
    ) {
        this.initDate = new BehaviorSubject(null);
        this.temInit = new BehaviorSubject(null);
    }

    ngOnInit(): void {
        this.tmp_start_date = null;
        // this.initCals();
        if (!moment(this.start).isValid()) {
            this.start = null;
        } else {
            this.currentFisrtDate = moment(this.start).startOf('month').format('YYYY-MM-DD');
        }
        this.initAvailabilityFirst();
        this.initAvailabilitySec();
        this.initMedia();
        this.initSub();
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    initMedia() {
       if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.media = 'xs';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.media = 'sm';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.media = 'md';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.media = 'lg';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.media = 'xl';
        }
        this.cdr.detectChanges();
    }

    initAvailabilityFirst() {
        for (let i = 0; i < this.jahresbelegung.length; i++) {
            if (moment(this.currentFisrtDate).year() === Number(this.jahresbelegung[i].jahr)) {
                this.currentYearFirst = this.jahresbelegung[i].availability;
                i = this.jahresbelegung.length;
            }
        }
    }

    initAvailabilitySec() {
        for (let i = 0; i < this.jahresbelegung.length; i++) {
            if (moment(this.currentSecondDate).year() === Number(this.jahresbelegung[i].jahr)) {
                this.currentYearSecond = this.jahresbelegung[i].availability;
                i = this.jahresbelegung.length;
            }
        }
    }

    /* async initCals () {
        const tmp_calendars = [];
        for (let i = 0; i < 36; i++) {
            const tmp_d = moment().startOf('month').add(i, 'months').format('YYYY-MM-DD');
            const tmp_month = this.initMonth(tmp_d);
            tmp_month.header = moment(tmp_d).format('MMMM, YYYY');
            tmp_month.class = 'cal_' + moment(tmp_d).format('YYYY-MM')

            tmp_calendars.push(tmp_month);
            this.cdr.detectChanges();
        }
        const source$ = from(tmp_calendars);
        const items = [];
        let count = 3;
        this.calendars = source$.pipe(
            bufferCount(count),
            concatMap((items, index) => of(items).pipe(delay(index === 0 ? 0 : 50))),
            map(arr => {
                count++;
                items.push(...arr);
                return [...items];
            })
        );
    } */

    initMonth(date: string, year): Calendar {
        moment.locale('de');

        const month = {
            w_0: [],
            w_1: [],
            w_2: [],
            w_3: [],
            w_4: [],
            w_5: [],
        };

        // const strd = Date.now();

        const tmp_days = Array.from({ length: moment(date).daysInMonth() }, (x, i) => moment(date).startOf('month').add(i, 'days').format('YYYY-MM-DD'));
        let start = moment(tmp_days[0]).day();
        if (start > 0) {
            start -= 1;
        } else {
            start = 6;
        }
        // console.log(start)
        for (let i = 0; i < start; i++) {
            tmp_days.unshift(null);
        }
        const end = 42 - tmp_days?.length;
        // console.log(end)
        for (let i = 0; i < end; i++) {
            tmp_days.push(null);
        }
        // console.log(tmp_days)
        for (let i = 0; i < tmp_days.length; i++) {
            if (tmp_days[i]) {
                if (month['w_' + Math.floor(i / 7)]?.length === 0) {
                    month['w_' + Math.floor(i / 7)] = Array.apply(null, Array(7));
                }

                let daySymbol = this.getAvailabilitySymbol(moment(tmp_days[i]).dayOfYear(), year);
                // const daySymbolm1 = this.getAvailabilitySymbol(moment(tmp_days[i - 1]).dayOfYear(), year);
                // const daySymbolp1 = this.getAvailabilitySymbol(moment(tmp_days[i + 1]).dayOfYear(), year);
                let overwrite = false;
                if (this.tmp_start_date?.length > 0) {
                    const diff = moment.duration(moment(tmp_days[i])
                        .diff(moment(this.tmp_start_date))).asDays();
                    if (diff >= 0) {
                        if ((daySymbol !== 'B' && daySymbol !== 'A')) {
                            if (moment(this.tmp_start_date).weekday() === moment(tmp_days[i]).weekday() && !this.alredyCut && diff <= 28) {
                                daySymbol = 'B';
                                overwrite = false;
                            } else {
                                this.alredyCut = true;
                                overwrite = true;
                            }
                        } else {
                            if (diff > 28 || this.alredyCut) {
                                overwrite = true;
                            }
                        }
                    }
                }
                month['w_' + Math.floor(i / 7)].splice(i % 7, 1, {
                    id: tmp_days[i],
                    value: tmp_days[i].slice(-2),
                    class: tmp_days[i] >= this.today
                        ? ((daySymbol === 'B' || daySymbol === 'A') && !overwrite ? 'class' + daySymbol
                            : 'disabledday') : '',
                    tooltip: this.categorys[daySymbol]
                });
            }
        }
        // console.log((Date.now() - strd) / 1000);
        // console.log(month);

        return month;
    }

    initSub() {
        this.initDate.asObservable().pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((data: any) => {
            if (data) {
                this.initCal();
            }
        });
        this.initDate.next({ first: this.currentFisrtDate, second: this.currentSecondDate });

        this.temInit.asObservable().pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((tmpdate) => {
            if (tmpdate?.id?.length > 0) {
                if (!this.end || this.end?.length === 0) {
                    this.tmp_end = tmpdate;
                } else {
                    this.tmp_end = null;
                }
            } else {
                this.tmp_end = null;
            }
        });
    }

    initCal() {
        this.initAvailabilityFirst();
        this.first_month = this.initMonth(this.currentFisrtDate, this.currentYearFirst);
        this.cdr.detectChanges();
        this.currentSecondDate = moment(this.currentFisrtDate).startOf('month').add(1, 'months').format('YYYY-MM-DD');
        this.initAvailabilitySec();
        this.first_header = moment(this.currentFisrtDate).format('MMMM, YYYY');
        this.second_month = this.initMonth(this.currentSecondDate, this.currentYearSecond);
        this.cdr.detectChanges();
        this.second_header = moment(this.currentSecondDate).format('MMMM, YYYY');
        this.cdr.detectChanges();
    }

    selectTmp_Day(md) {
        this.temInit.next(md);
    }

    previus() {
        this.currentFisrtDate = moment(this.currentFisrtDate).startOf('month').subtract(1, 'months').format('YYYY-MM-DD');
        this.initDate.next({ first: this.currentFisrtDate, second: this.currentSecondDate });
    }

    next() {
        this.currentFisrtDate = moment(this.currentFisrtDate).startOf('month').add(1, 'months').format('YYYY-MM-DD');
        this.initDate.next({ first: this.currentFisrtDate, second: this.currentSecondDate });
    }

    selectDay(md: Month) {
        this.alredyCut = false;
        if (md?.id?.length > 0 && md.class === 'classB') {
            if (this.end?.length > 0 && this.start?.length > 0) {
                this.end = '';
                this.start = md.id;
                this.tmp_start_date = md.id;
                this.initDate.next({ first: this.currentFisrtDate, second: this.currentSecondDate });
                this.sendStart.emit(this.start);
            } else {
                if (this.start?.length > 0 && this.start < md.id) {
                    this.end = md.id;
                    this.sendEnd.emit(this.end);
                } else {
                    this.start = md.id;
                    this.tmp_start_date = md.id;
                    this.initDate.next({ first: this.currentFisrtDate, second: this.currentSecondDate });
                    this.sendStart.emit(this.start);
                }
            }
        }
        this.cdr.detectChanges();
    }

    trackByFn(index, item) {
        return item?.id;
    }

    getAvailabilitySymbol(day: number, year): string {
        if (year?.length > 0) {
            return String(year.slice(day - 1, day))?.trim()?.toLocaleUpperCase();
        } else {
            return 'O';
        }
    }
}
